import React from 'react'
import { filterEmoji } from 'Constants/emoji'
import HotHeader from 'Components/new/hot/hot-header'
import koubeiLink from 'Components/new/links/koubei-link'
import ugcDetailLink from 'Components/new/links/ugc-detail-link'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import HotItem from 'Components/new/hot/hot-item'
import HotLayout from 'Components/new/hot/hot-layout'

const IconHotTalk = require('static/icon-hot-talk.svg')
interface IHotTalkCommunityProps {
  cheyouHotCard: any
  series_id: string
  series_name: string
}
const HotTalkCommunity: React.FC<IHotTalkCommunityProps> = ({
  cheyouHotCard,
  series_id,
  series_name,
}) => {
  const koubeiarr = [12, 13, 14]
  const hotArr =
    cheyouHotCard?.map?.((item: any) => {
      const content = filterEmoji(item?.title || item?.content)
      if (content) {
        return { ...item, content }
      }
    }) || []

  return (
    <HotLayout
      className="hot-talk-wrapper tw-bg-white tw-px-16 tw-mb-12 tw-w-full md:tw-pb-0 tw-pb-12 tw-rounded-2"
      smRows={2}
      smCols={2}
      gap={6}
      slideClass="tw-w-1/2 md:tw-w-full"
      slideCount={hotArr?.length || 0}
      title={<HotHeader src={IconHotTalk} title={'圈子热议'} />}
    >
      {({ index }) => {
        const item = hotArr[index]
        const id = item?.gid_str
        return (
          <React.Fragment key={index}>
            {(koubeiarr.includes(item?.article_sub_type)
              ? koubeiLink({ id })
              : ugcDetailLink({ id }))(
              <HotItem
                index={index}
                commentText={item?.article_sub_type === 8 ? '回答' : '评论'}
                content={item?.content}
                commentCount={item?.comment_count}
                diggCount={item?.digg_count}
                hasImage={item?.image_urls?.length}
                hasVideo={item?.video_detail_info?.video_id}
                questionInfo={item?.question_info}
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    page_id: 'page_ugc_forum_home',
                    event_id: 'forum_home_hot_discussion',
                    car_series_id: String(series_id),
                    car_series_name: series_name,
                    module_id: 'ugc_detail_tuijian',
                    group_id: item?.gid_str,
                    author_id: item?.user_id_str,
                  })
                }}
              />
            )}
          </React.Fragment>
        )
      }}
    </HotLayout>
  )
}
export default HotTalkCommunity
